import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {Shortcuts} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/KeyboardController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./ClipboardHintDialog.less');
const cx = classnames.bind(styles);

export class ClipboardHintDialog extends React.Component<any, any>
{
    private _handleClose = ():void =>
    {
        controllers.ui.dialogs.hideDialog(Dialogs.ClipboardHint);
    };

    public render():JSX.Element
    {
        const {keyboard} = controllers.ui;

        return (
            <Dialog title="Copying and pasting">
                <Row>These actions are unavailable using the Edit menus, but you can still use:</Row>

                <Row className={cx('commandsRow')}>
                    <Column>
                        <div className={cx('command')}>
                            {keyboard.getShortcutLabel(Shortcuts.COPY)}
                        </div>
                        <div>for copy</div>
                    </Column>
                    <Column>
                        <div className={cx('command')}>
                            {keyboard.getShortcutLabel(Shortcuts.CUT)}</div>
                        <div>for cut</div>
                    </Column>
                    <Column>
                        <div className={cx('command')}>
                            {keyboard.getShortcutLabel(Shortcuts.PASTE)}
                        </div>
                        <div>for paste</div>
                    </Column>
                </Row>

                <Row className={cx('actionRow')}>
                    <WSPButton
                        style={ButtonStyle.SimpleSecondary}
                        onClick={this._handleClose}
                    >
                        Close
                    </WSPButton>
                </Row>
            </Dialog>
        );
    }
}
